import {RestService} from "@/services/rest/RestService";
import {SimpleContentBlockEndpointsApi} from "@/api/pharma-cms-content-block";
import {
    SimpleDocumentContentRestDto,
    SimpleTextContentRestDto,
    SimpleTextWithImageContentRestDto
} from "@/api/pharma-cms-content-block/models";
import {
    SimpleTextContentRestDtoModel
} from "@/models/api/pharma-cms-simple-content-block/SimpleTextContentRestDtoModel";
import {AxiosResponse} from "axios";
import {
    SimpleDocumentContentRestDtoModel
} from "@/models/api/pharma-cms-simple-content-block/SimpleDocumentContentRestDtoModel";
import {isValidButton} from "@/helpers/functions/content_blocks/validation";
import {
    SimpleTextWithImageContentRestDtoModel
} from "@/models/api/pharma-cms-content-block/SimpleTextWithImageContentRestDtoModel";

export class SimpleContentBlockRestService extends RestService {
    private apiService: SimpleContentBlockEndpointsApi;

    protected constructor() {
        super();
        this.apiService = new SimpleContentBlockEndpointsApi(this.getDpAxiosInstance(), undefined, this.getApiGwUrl('/pharma-cms'));
    }

    public async getSimpleContentBlockText(type: string): Promise<SimpleTextContentRestDtoModel> {
        const response = await this.apiService.getSimpleContentBlockText(type);

        if (response.status === 204) {
            return SimpleTextContentRestDtoModel.createWithDefaults();
        }

        return response.data as SimpleTextContentRestDtoModel;
    }

    public async updateSimpleContentBlockText(type: string, dto: SimpleTextContentRestDto): Promise<void> {
        await this.apiService.updateSimpleContentBlockText(dto, type);
    }

    public async updateSimpleContentBlockTextWithImage(type: string, dto: SimpleTextWithImageContentRestDto): Promise<void> {
        dto.button = isValidButton(dto.button) ? dto.button : null;

        await this.apiService.updateSimpleContentBlockTextWithImage(dto, type);
    }

    public async getSimpleContentBlockTextWithImage(type: string): Promise<SimpleTextWithImageContentRestDto> {
        const response: AxiosResponse<SimpleTextWithImageContentRestDto> = await this.apiService.getSimpleContentBlockTextWithImage(type);

        if (response.status === 204) {
            return SimpleTextWithImageContentRestDtoModel.createWithDefaults();
        }

        return response.data;
    }

    public async getSimpleContentBlockDocument(type: string): Promise<SimpleDocumentContentRestDto> {
        const response: AxiosResponse<SimpleDocumentContentRestDto> = await this.apiService.getSimpleContentBlockDocument(type);

        if (response.status === 204) {
            return SimpleDocumentContentRestDtoModel.createWithDefaults();
        }

        return response.data;
    }

    public async getStandardSimpleContentBlockDocument(type: string): Promise<SimpleDocumentContentRestDto> {
        const response: AxiosResponse<SimpleDocumentContentRestDto> = await this.apiService.getStandardSimpleContentBlockDocument(type);

        if (response.status === 204) {
            return SimpleDocumentContentRestDtoModel.createWithDefaults();
        }

        return response.data;
    }

    public async updateSimpleContentBlockDocument(type: string, dto: SimpleDocumentContentRestDto): Promise<void> {
        await this.apiService.updateSimpleContentBlockDocument(dto, type);
    }

    public async deleteSimpleContentBlock(type: string): Promise<void> {
        await this.apiService.deleteSimpleContentBlock(type);
    }
}
